<template>
  <!-- Required by FedEx on every screen showing FedEx names or marks (Additional Guidance 3c), minimum 8pt -->
  <div class="fedex-disclaimer grey--text text--darken-1" :class="{ 'text-center': centered }">
    The FedEx service marks are owned by Federal Express Corporation and are used by permission.
  </div>
</template>

<script>
export default {
  name: 'FedExDisclaimer',
  props: {
    centered: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.fedex-disclaimer {
  font-size: 11px;
  line-height: 1.3;
}
</style>
